import React, { useEffect, useState, useContext } from 'react'
import ListingTableView from '@/product/components/organisms/Product/TableView'
import { Button } from '@mui/material'
import ReportContext from '@/product/context/report/reportContext'
import DynamicAuctionListing from '../AuctionLots/dynamicListing'
import { useFormik } from 'formik'
import AuctionContext from '@/product/context/auction/auctionContext'
import DynamicListing from '../Listing/dynamicListing'
import DynamicBulkListing from '@/product/components/organisms/BulkUpload/ProjectUpload'
import DynamicManifest from '@/product/components/organisms/BulkUpload/ManifestUpload'
import DynamicBulkImage from '@/product/components/organisms/BulkUpload/ProjectImage'
import CustomCommonContext from '@/custom/context/common/commonContext'
import { useHistory } from 'react-router-dom'
import { handleRedirectInternal } from '@/product/common/components'
import ManifestContext from '@/product/context/manifest/manifestContext'
import PropTypes from 'prop-types'

import CatalogSearch from './CatalogSearch'
import AiSearch from './AiSearch'

const Manifest = (props) => {
    const { getAllExportDownload } = useContext(ReportContext)
    const { sampleXLSXFile } = useContext(ManifestContext)

    const { alldata_all_dropdown } = useContext(CustomCommonContext)
    const [configValues, setConfigValues] = useState({
        qty: 1,
        auction: 1,
    })

    const history = useHistory()

    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
    })
    const [auctionManage, setAuctionManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
    })
    const [bulkPopup, setBulkPopup] = useState(false)
    const [aucId, setAucId] = useState('')
    const [lotStatus, setLotStatus] = useState('')
    const [bulkImagePopup, setBulkImagePopup] = useState(false)
    const [catalogPopup, setCatalogPopup] = useState(false)
    const [imagePopup, setImagePopup] = useState(false)
    const [vinPopup, setVinPopup] = useState(false)

    const [aiPopup, setAiPopup] = useState(false)
    const [manifestPopup, setManifestPopup] = useState(false)

    const toggleBulkImagePopup = (popup) => {
        setBulkImagePopup({ popup })
    }
    const toggleCatalogPopup = (popup) => {
        setCatalogPopup({ popup })
    }
    const toggleAiPopup = (popup) => {
        setAiPopup({ popup })
    }

    const toggleBulkPopup = (popup) => {
        setBulkPopup({ popup })
    }

    const toggleManifestPopup = (popup) => {
        setManifestPopup({ popup })
    }

    const manifestUploadFields = [
        {
            id: 1,
            isRequired: true,
            name: 'fetch_type',
            type: 'select',
            label: 'fetch_type',
            placeholder: 'Select Fetch type',
            options: [
                { value: 'asin', show: 'asin' },
                // { value: 'HOME_DEPOT', show: 'HOME DEPOT' },
                { value: 'upc', show: 'upc' },
            ],
        },
        {
            id: 2,
            isRequired: true,
            label: 'fetch_id',
            placeholder: 'Enter Fetch ID',
            type: 'text',
            name: 'fetch_id',
        },
        {
            id: 3,
            isRequired: false,
            colId: 1,
            label: 'title',
            placeholder: 'Enter Title',
            type: 'text',
            name: 'title',
        },
        {
            id: 4,
            isRequired: true,
            colId: 2,
            name: 'conditiontypeid',
            type: 'select',
            label: 'conditiontypeid',
            placeholder: 'Select Condition',
            options: alldata_all_dropdown
                .filter(
                    (value) =>
                        value.variable === 'conditiontypeid' &&
                        value.level === 0
                )
                .map((item) => {
                    let valueChanged = {}
                    valueChanged.show = item.description
                    valueChanged.value = item.id
                    return valueChanged
                }),
        },
        {
            id: 5,
            isRequired: true,
            colId: 3,
            name: 'category',
            type: 'select',
            label: 'category',
            placeholder: 'Select Category',
            options: alldata_all_dropdown
                .filter(
                    (value) =>
                        value.variable === 'category' && value.level === 0
                )
                .map((item) => {
                    let valueChanged = {}
                    valueChanged.show = item.description
                    valueChanged.value = item.id
                    return valueChanged
                }),
        },
        {
            id: 6,
            isRequired: false,
            colId: 4,
            name: 'desc_proc',
            type: 'text',
            label: 'desc_proc',
            placeholder: 'Enter Description',
        },
        {
            id: 7,
            isRequired: false,
            colId: 5,
            name: 'payment_details',
            type: 'text',
            label: 'payment_details',
            placeholder: 'Enter Payment Details',
        },
        {
            id: 8,
            isRequired: false,
            colId: 6,
            name: 'pick_up_details',
            type: 'text',
            label: 'pick_up_details',
            placeholder: 'Enter Pickup Details',
        },
        {
            id: 9,
            isRequired: false,
            colId: 7,
            name: 'shipping_details',
            type: 'text',
            label: 'shipping_details',
            placeholder: 'Enter Shipping Details',
        },
        {
            id: 10,
            isRequired: false,
            colId: 8,
            name: 'returns_details',
            type: 'text',
            label: 'returns_details',
            placeholder: 'Enter Return Details',
        },
        {
            id: 11,
            isRequired: false,
            colId: 9,
            name: 'condition_details',
            type: 'text',
            label: 'condition_details',
            placeholder: 'Enter Condition Details',
        },
        {
            id: 12,
            isRequired: true,
            colId: 10,
            name: 'sprice',
            type: 'decimal',
            label: 'sprice',
            placeholder: 'Enter your Start price',
        },
        {
            id: 13,
            isRequired: false,
            colId: 11,
            name: 'shipping_check',
            type: 'number',
            label: 'shipping_check',
            placeholder: 'Shipping Check',
        },
        {
            id: 14,
            isRequired: false,
            colId: 12,
            name: 'dimension_length',
            type: 'number',
            label: 'dimension_length',
            placeholder: 'Enter Length',
        },
        {
            id: 15,
            isRequired: false,
            colId: 13,
            name: 'dimension_width',
            type: 'number',
            label: 'dimension_width',
            placeholder: 'Enter Width',
        },
        {
            id: 16,
            isRequired: false,
            colId: 14,
            name: 'dimension_height',
            type: 'number',
            label: 'dimension_height',
            placeholder: 'Enter Height',
        },
        {
            id: 17,
            isRequired: false,
            colId: 15,
            name: 'weight_value',
            type: 'number',
            label: 'weight_value',
            placeholder: 'Enter Weight',
        },
        {
            id: 18,
            isRequired: false,
            colId: 16,
            name: 'local_pickup_check',
            type: 'number',
            label: 'local_pickup_check',
            placeholder: 'Local Pickup',
        },
        {
            id: 19,
            isRequired: true,
            colId: 17,
            name: 'lot_location',
            type: 'select',
            label: 'lot_location',
            placeholder: 'Select Location',
            options: alldata_all_dropdown
                .filter(
                    (value) =>
                        value.variable === 'location_id' && value.level === 0
                )
                .map((item) => {
                    let valueChanged = {}
                    valueChanged.show = item.description
                    valueChanged.value = item.id
                    return valueChanged
                }),
        },
        {
            id: 20,
            isRequired: false,
            colId: 18,
            name: 'plus_member',
            type: 'number',
            label: 'plus_member',
            placeholder: 'Plus Member',
        },
    ]

    const addSequentialIdsWithMap = (arrayOfObjects) => {
        return arrayOfObjects.map((obj, index) => ({
            ...obj,
            id: index + 1,
            colId: index + 1,
        }))
    }

    const sortedFieldList = addSequentialIdsWithMap(manifestUploadFields)

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const toggleAuctionPopup = (popup, status, id) => {
        if (popup) {
            setAuctionManage({ popup, status, id })
        } else {
            setAuctionManage({ popup, status: 'new', id: 0 })
        }
    }

    return (
        <>
            <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4 erp-menus-list">
                {props?.type === 'manifest' ? (
                    <>
                        {' '}
                        <Button
                            id="manifest_upload"
                            variant="outlined"
                            className="btnOutlined mr-2"
                            onClick={() => toggleManifestPopup(true)}
                        >
                            <span className="material-icons-outlined">
                                file_upload
                            </span>
                            Manifest Upload
                        </Button>{' '}
                        <Button
                            id="listingDynamic_report"
                            variant="outlined"
                            className="btnOutlined mr-2"
                            onClick={() => sampleXLSXFile()}
                        >
                            <span className="material-icons-outlined">
                                file_download
                            </span>
                            Manifest Template
                        </Button>
                    </>
                ) : (
                    <>
                        {' '}
                        <Button
                            id="dynamicAuction_add"
                            variant="outlined"
                            className="btnOutlined mr-2"
                            onClick={() =>
                                handleRedirectInternal(history, `auction/new/0`)
                            }
                        >
                            <span className="material-icons">add</span>
                            Create new auction
                        </Button>{' '}
                        <Button
                            id="listingDynamic_add"
                            variant="outlined"
                            className="btnOutlined mr-2"
                            onClick={() =>
                                handleRedirectInternal(history, `listing/new/0`)
                            }
                        >
                            <span className="material-icons">add</span>
                            Add single inventory
                        </Button>
                        <Button
                            variant="outlined"
                            className="btnOutlined mr-2"
                            onClick={() => toggleCatalogPopup(true)}
                        >
                            <span className="material-icons-outlined">
                                manage_search
                            </span>
                            Catalog search
                        </Button>
                        <Button
                            variant="outlined"
                            className="btnOutlined mr-2"
                            onClick={() => toggleAiPopup(true)}
                        >
                            <span className="material-icons-outlined">
                                screen_search_desktop
                            </span>
                            AI search
                        </Button>
                        <Button
                            id="listingDynamic_bulk"
                            variant="outlined"
                            className="btnOutlined mr-2"
                            onClick={() => toggleBulkPopup(true)}
                        >
                            <span className="material-icons-outlined">
                                inventory_2
                            </span>
                            Add bulk inventory
                        </Button>{' '}
                        <Button
                            variant="outlined"
                            className="btnOutlined mr-2"
                            onClick={() => toggleBulkImagePopup(true)}
                        >
                            <span className="material-icons-outlined">
                                collections
                            </span>
                            Add bulk images
                        </Button>{' '}
                        <Button
                            id="listingDynamic_report"
                            variant="outlined"
                            className="btnOutlined mr-2"
                            onClick={() =>
                                getAllExportDownload({
                                    action: 'export',
                                    order: 'asc',
                                    orderby: '',
                                    search: 'all',
                                    report: `${lotStatus}_product_management`,
                                })
                            }
                        >
                            <span className="material-icons-outlined">
                                file_download
                            </span>
                            Export All Data
                        </Button>
                    </>
                )}
            </div>
            <CatalogSearch data={catalogPopup} function={toggleCatalogPopup} />
            <AiSearch data={aiPopup} function={toggleAiPopup} />
            <DynamicBulkListing
                data={bulkPopup}
                function={toggleBulkPopup}
                ignoreFields={
                    global?.bulk_ignoreFields ? global.bulk_ignoreFields : []
                }
            />
            <DynamicBulkImage
                data={bulkImagePopup}
                function={toggleBulkImagePopup}
                explanationText={`Bulk Image Upload reads the file name of each image and will automatically add to the listings image. The name of the files has to be given in the format of {ListingField}-{N}.{ImageFormat} or {ListingField} ({N}).{ImageFormat}. <br />  {ListingField} From Listing Posting: "Lot ID" Field has to be given. <br/> {N} Number - Can be any number, as uploading multiple images with same name is not possible, When renaming the number will be automatically added by OS (Mac or Windows). <br /> {ImageFormat} Image Format: Image Format can be .jpg, .png or .webp.`}
                separatorFunction={[
                    // {
                    //     symbol: '_',
                    //     field: 'cac.auction_cycle',
                    //     table: 'auction',
                    //     show: 'Auction Cycle',
                    // },
                    {
                        symbol: '_',
                        field: 'p.id',
                        table: 'project',
                        show: 'Lot ID',
                    },
                ]}
                isCompress={global?.isCompress ? global.isCompress : false}
            />
            <DynamicManifest
                data={manifestPopup}
                function={toggleManifestPopup}
                dataFields={sortedFieldList}
                asinFieldMappings={{
                    title: 'title',
                    desc_proc: 'title',
                    category: 'productGroup',
                    sprice: 'lowestNewPrice',
                    dimension_length: 'length',
                    dimension_width: 'width',
                    dimension_height: 'height',
                    weight_value: 'weight',
                }}
                noFields={global.noFields}
                ignoreFields={[
                    'uploadimages',
                    'wprice',
                    'date_added',
                    'date_closed',
                    'asin',
                    'auction',
                    'mpn',
                ]}
                preFillFields={configValues}
                showWithId={true}
                requiredFields={['fetch_type', 'fetch_id']}
                acceptDuplicateItem={props?.acceptDuplicateItem}
                skipRetailerFetch={props.skipRetailerFetch}
            />
        </>
    )
}

export default Manifest
